import { render, staticRenderFns } from "./TreeCotejo.vue?vue&type=template&id=5ec4a027&scoped=true"
import script from "./TreeCotejo.vue?vue&type=script&lang=js"
export * from "./TreeCotejo.vue?vue&type=script&lang=js"
import style0 from "./TreeCotejo.vue?vue&type=style&index=0&id=5ec4a027&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4a027",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec4a027')) {
      api.createRecord('5ec4a027', component.options)
    } else {
      api.reload('5ec4a027', component.options)
    }
    module.hot.accept("./TreeCotejo.vue?vue&type=template&id=5ec4a027&scoped=true", function () {
      api.rerender('5ec4a027', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/TreeCotejo.vue"
export default component.exports